export default __webpack_public_path__ + "static/storquest-logo-fae2ed0bac9490773a0edde112053a58.png";